import { render, staticRenderFns } from "./TemplatesMail.vue?vue&type=template&id=4a6ec7aa&scoped=true&"
import script from "./TemplatesMail.vue?vue&type=script&lang=js&"
export * from "./TemplatesMail.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesMail.vue?vue&type=style&index=0&id=4a6ec7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ec7aa",
  null
  
)

export default component.exports